package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.grid_customer_card_bar

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum

import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card.LoyaltyCardItem
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.grid_function.FilterActiveGridContent
import org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.grid_customer_card_bar.component.CustomerCardGridFunction
import org.hs_soft.runmynesto.pages.components.FilterRow

@Composable
fun GridCustomerCardBar(
    windowSizeMode:WindowSizeModeEnum,
    selectedItemId:String,
    loyaltyCardItems: List<LoyaltyCardItem?>?,
    showFilterComponent: Boolean,
    selectedFilterOption: GridItemsFilterEnum,
    setFilterComponentVisibility:(Boolean)->Unit,
    onSearchValueChange: (String) -> Unit,
    onAddRecord: () -> Unit,
    selectFilterType: (GridItemsFilterEnum) -> Unit,
    submitFilterItems: () -> Unit,
    onItemClick:(String)->Unit,
    loadMoreData:()->Unit,
    onSwipeRight: () -> Unit,
) {
    Column(
        modifier = Modifier
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
            .fillMaxHeight()
    )

    {
        FilterRow(
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            width =Dimen.gridCustomerCardWidth,
            selectedFilterType = selectedFilterOption,
            onAddRecordClick = {
                onAddRecord()
            },
            onFilterClick = {
                setFilterComponentVisibility(!showFilterComponent)
            },
        )

        Box(
            modifier = Modifier
                .weight(1f)
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .margin(top = Dimen.normalPadding)
        )
        {
            if (showFilterComponent){
                FilterActiveGridContent(
                    selectFilterType = {
                        selectFilterType(it)
                    },
                    selectedFilterType=selectedFilterOption,
                    onCloseFilterClick ={
                        setFilterComponentVisibility(false)
                    },
                    submitFilterItems = {
                        submitFilterItems()
                    }

                )
            }

            Column(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode==WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
                    .fillMaxHeight()
            ) {
                CustomEditText(
                    width =Dimen.gridCustomerCardWidth,
                    label = "",
                    value = "",
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    endIconPath = Res.PathIcon.searchBox,
                    isRequired = false,
                    hint = Strings.current().search,
                    onFocusIn = {},
                    onFocusOut = {},
                    onInputChange = {it, validation ->
                        onSearchValueChange(it)
                    },
                )

                CustomerCardGridFunction(
                    fillMaxWidth=windowSizeMode==WindowSizeModeEnum.PHONE,
                    items=loyaltyCardItems?: listOf(),
                    id =selectedItemId ,
                    onItemClick = {
                        onItemClick(it)
                    },
                    loadMoreData = {
                        loadMoreData()
                    }

                )



            }
        }




    }
}